import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the Add client flow still reads from the workspace: the open flags and form state that other pages, the URL handler and start-up code set (Add / Edit Client, Add Contact, Create User), the directory lists and loaders it refreshes after a save, and the service catalogue.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsAddFlowHost = Pick<
  PmWorkspaceComponent,
  | 'activeDropdown'
  | 'applyClientsAddContactModalDefaults'
  | 'applyDefaultServicesResponse'
  | 'assignmentColumnIds'
  | 'catalogServiceVisibleForAddClientType'
  | 'catalogServices'
  | 'clientsAddActiveDropdown'
  | 'clientsAddAssignDirectorOptions'
  | 'clientsAddAssignDirectorSearch'
  | 'clientsAddAssignDirectorSelected'
  | 'clientsAddChOfficers'
  | 'clientsAddChOfficersSa'
  | 'clientsAddChOfficersSelected'
  | 'clientsAddClientIdDuplicate'
  | 'clientsAddClientTypeOptions'
  | 'clientsAddContactContext'
  | 'clientsAddContactDraft'
  | 'clientsAddContactModalOpen'
  | 'clientsAddContactOptions'
  | 'clientsAddCountries'
  | 'clientsAddCurrencies'
  | 'clientsAddCustomFieldValues'
  | 'clientsAddCustomFieldsForModal'
  | 'clientsAddCustomFieldsLoading'
  | 'clientsAddDirectorDeleteIds'
  | 'clientsAddDirectorDraft'
  | 'clientsAddDirectorsSeedVersion'
  | 'clientsAddDirectorEditIndex'
  | 'clientsAddDirectorFormOpen'
  | 'clientsAddDirectors'
  | 'clientsAddDraft'
  | 'clientsAddDraftSavePending'
  | 'clientsAddEditClientUniversalId'
  | 'clientsAddEditCompanyMasterId'
  | 'clientsAddEditOriginalLinkedContactIds'
  | 'clientsAddEditClientStoreContactIdByPracticeId'
  | 'clientsAddEditReturnUrl'
  | 'clientsAddFormMode'
  | 'clientsAddFormOpen'
  | 'clientsAddKeyContactDropdownOpen'
  | 'clientsAddKeyContactIds'
  | 'clientsAddKeyContactPanelStyle'
  | 'clientsAddPanelsOpen'
  | 'clientsAddPendingPortalUserDrafts'
  | 'clientsAddPopupExtras'
  | 'clientsAddPortalContactLoading'
  | 'clientsAddPortalContactOptions'
  | 'clientsAddPortalContactsLoadAttempted'
  | 'clientsAddPortalUserOptions'
  | 'clientsAddPrimaryContactDropdownOpen'
  | 'clientsAddPrimaryContactOptionsRaw'
  | 'clientsAddPrimaryContactPanelStyle'
  | 'clientsAddRegNoDuplicateError'
  | 'clientsAddSAIndividualOptions'
  | 'clientsAddSelectionOpen'
  | 'clientsAddShowConfirmPassword'
  | 'clientsAddShowFooterErrors'
  | 'clientsAddShowPassword'
  | 'clientsAddSicTags'
  | 'clientsAddSourceSelectOptions'
  | 'clientsAddVatSchemes'
  | 'clientsAddVatSubmitTypes'
  | 'clientsCompanyHouseApplyingId'
  | 'clientsCompanyHouseModalOpen'
  | 'clientsCompanyHouseResults'
  | 'clientsCompanyHouseSearch'
  | 'clientsCompanyHouseSearchError'
  | 'clientsCreateClientUserContactOptions'
  | 'clientsCreateClientUserContactsLoadAttempted'
  | 'clientsCreateClientUserContactsLoading'
  | 'clientsCreateClientUserDraft'
  | 'clientsCreateClientUserModalOpen'
  | 'clientsDirectoryPageNumber'
  | 'clientsDirectoryRows'
  | 'clientsEditClientUserContactId'
  | 'clientsEditClientUserLoading'
  | 'clientsEditClientUserLoginName'
  | 'clientsEditingDraftId'
  | 'clientsListAddContactClientName'
  | 'clientsListAddContactClientUniversalId'
  | 'clientsListAddContactCompanyMasterId'
  | 'clientsPageTab'
  | 'clientsPageView'
  | 'closeClientsAddActiveDropdown'
  | 'closeClientsAddFormModal'
  | 'collectExistingClientReferenceIds'
  | 'createClientUserConfirmPassword'
  | 'createClientUserConfirmPasswordVisible'
  | 'createClientUserContactChoice'
  | 'createClientUserLaunchSource'
  | 'createClientUserPasswordVisible'
  | 'customAddedServices'
  | 'customFields'
  | 'customServiceVisibleForAddClientType'
  | 'effectiveDirectoryActingUserIdForContacts'
  | 'effectiveDirectoryParentUserId'
  | 'effectiveDirectoryUserIdForClientsList'
  | 'ensureClientUsersFirmTotalCount'
  | 'invalidateDirectoryClientsCache'
  | 'lastClientsUsersFirmCountKey'
  | 'lastClientsUsersHydrationLoadKey'
  | 'loadAssignmentsMatrixForTab'
  | 'loadClientsAddMasterDataFromClientStore'
  | 'loadClientsDraftList'
  | 'loadDirectoryClientUsers'
  | 'loadDirectoryClientsPage'
  | 'navigateDdList'
  | 'notifyError'
  | 'onClientsAddModalSurfaceClick'
  | 'openClientsAddFormModal'
  | 'pendingCrmConversionSource'
  | 'persistClientsAddPrimaryContact'
  | 'profile'
  | 'refreshBookMeetingPickerIfNeeded'
  | 'removeSicTag'
  | 'scheduleClientsAddRegNoDuplicateCheck'
  | 'setClientsAddField'
  | 'syncClientsAddClientIdDuplicate'
  | 'teamMembersApi'
>;

export const PM_CLIENTS_ADD_FLOW_HOST = new InjectionToken<PmClientsAddFlowHost>('PmClientsAddFlowHost');
